export const bodyWithLink = `
  We're not quite sure what went wrong. Restart your browser. If this doesn't solve
  the problem, visit our <a href="{supportCenterLink}" target="_blank">Support Center</a>.
`;
